import cn from 'clsx';
import { AnchorHTMLAttributes, ReactNode } from 'react';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
}

export default function DesktopMenuLink({ href, children, className, ariaLabel, ...props }: Props) {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      className={cn(
        'inline-flex font-semibold px-3 py-2 rounded-md cursor-pointer whitespace-nowrap',
        'text-slate-800 hover:text-slate-900 active:text-slate-950',
        'bg-white hover:bg-slate-100 active:bg-slate-200',
        className
      )}
      {...props}
    >
      {children}
    </a>
  );
}
